var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDtcAppLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 340,
    height: 240,
    viewBox: "0 0 132.762 131.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.003,
    y1: 1.087,
    x2: 0.095,
    y2: 0.056,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3.614,
    y1: -3.257,
    x2: -0.159,
    y2: 2.36,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2.711,
    y1: -4.664,
    x2: 0.627,
    y2: 1.782,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 7.173,
    y1: -5.873,
    x2: 3.287,
    y2: 0.341,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a737d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef497a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 8.221,
    y1: -6.977,
    x2: 4.335,
    y2: -0.764,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 9.156,
    y1: -6.941,
    x2: 4.042,
    y2: -0.262,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 10.317,
    y1: -9.187,
    x2: 6.43,
    y2: -2.973,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2.509,
    y1: -3.677,
    x2: -7.471,
    y2: 1.65,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1.519,
    y1: -0.775,
    x2: -1.484,
    y2: 2.907,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1.004,
    y1: -2.464,
    x2: -0.074,
    y2: 4.125,
    xlinkHref: "#linear-gradient-9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "app01",
    transform: "translate(-459.969 -455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13232",
    "data-name": "Path 13232",
    d: "M605.982,568.07c-24,25.327-60.867,17.835-66.316,16.631-6.865-1.517-23.2-5.126-35.387-19.375-18.661-21.816-16.776-55.91-2.365-78.9,4.193-6.688,18.305-26.565,44.807-30.887,1.549-.253,29.222-4.31,51.488,14.372a60.972,60.972,0,0,1,12.1,13.723C623.478,504.242,629.713,543.026,605.982,568.07Z",
    transform: "translate(-29.261 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11367",
    "data-name": "Group 11367",
    transform: "translate(504.681 460.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13233",
    "data-name": "Path 13233",
    d: "M1418.434,562.176a2.227,2.227,0,0,1,2.93-1.653c8.465,3.018,37.659,12.988,62.834,16.308a2.06,2.06,0,0,1,1.77,2.358l-14.646,93.965a2.37,2.37,0,0,1-2.693,1.98c-10.55-1.579-53.963-8.24-68.931-13.069a1.878,1.878,0,0,1-1.261-2.165Z",
    transform: "translate(-1398.399 -560.393)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13234",
    "data-name": "Path 13234",
    d: "M1444.756,616.932a2.143,2.143,0,0,1,2.82-1.591c8.146,2.9,36.241,12.5,60.468,15.694a1.982,1.982,0,0,1,1.7,2.269l-14.094,90.427a2.281,2.281,0,0,1-2.592,1.905c-10.152-1.52-51.931-7.929-66.335-12.576a1.807,1.807,0,0,1-1.213-2.083Z",
    transform: "translate(-1424.185 -612.604)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13235",
    "data-name": "Path 13235",
    d: "M1900.906,806.974a1.324,1.324,0,0,0-1.625,1.073l-3.15,19.36a1.245,1.245,0,0,0,.938,1.412c3.53.848,14.537,3.45,20.853,4.441a1.391,1.391,0,0,0,1.566-1.044c.877-3.57,3.343-13.98,3.446-18.528a1.57,1.57,0,0,0-1.195-1.557Z",
    transform: "translate(-1872.4 -795.188)",
    fill: "#fff",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_410",
    "data-name": "Ellipse 410",
    cx: 4.212,
    cy: 4.212,
    r: 4.212,
    transform: "matrix(0.361, -0.932, 0.932, 0.361, 32.063, 24.664)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13236",
    "data-name": "Path 13236",
    d: "M1983.558,1162.888l13.13,2.767a1.039,1.039,0,0,0,1.184-1.387,8.66,8.66,0,0,0-6.606-5.772,9.354,9.354,0,0,0-8.226,2.536A1.086,1.086,0,0,0,1983.558,1162.888Z",
    transform: "translate(-1954.856 -1129.849)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11355",
    "data-name": "Group 11355",
    transform: "translate(55.692 19.007)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13237",
    "data-name": "Path 13237",
    d: "M2590.62,965.9a.694.694,0,0,0,.864-.49.761.761,0,0,0-.628-.818l-22.927-5.26a.5.5,0,0,0-.645.587l.044.336a1.159,1.159,0,0,0,.847.915Z",
    transform: "translate(-2567.278 -959.311)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11356",
    "data-name": "Group 11356",
    transform: "translate(54.939 22.581)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13238",
    "data-name": "Path 13238",
    d: "M2552.12,1034.344a.5.5,0,0,0-.645.587l.044.336a1.159,1.159,0,0,0,.847.915l22.444,4.73a.694.694,0,0,0,.865-.49.761.761,0,0,0-.628-.818Z",
    transform: "translate(-2551.468 -1034.325)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11357",
    "data-name": "Group 11357",
    transform: "translate(54.175 26.207)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13239",
    "data-name": "Path 13239",
    d: "M2536.08,1110.448a.5.5,0,0,0-.645.587l.044.336a1.159,1.159,0,0,0,.847.915l22.444,4.73a.694.694,0,0,0,.865-.489.761.761,0,0,0-.628-.818Z",
    transform: "translate(-2535.429 -1110.429)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11358",
    "data-name": "Group 11358",
    transform: "translate(21.951 37.634)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13240",
    "data-name": "Path 13240",
    d: "M1913.222,1363.388a.665.665,0,0,0,.841-.495.787.787,0,0,0-.653-.816l-53.825-11.788c-.41-.09-.592.144-.4.52l.324.646a1.8,1.8,0,0,0,1.09.841Z",
    transform: "translate(-1859.105 -1350.271)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11359",
    "data-name": "Group 11359",
    transform: "translate(21.197 41.208)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13241",
    "data-name": "Path 13241",
    d: "M1843.774,1425.3c-.41-.09-.592.144-.4.52l.324.646a1.8,1.8,0,0,0,1.09.841l52.628,11.092a.664.664,0,0,0,.841-.495.786.786,0,0,0-.653-.816Z",
    transform: "translate(-1843.295 -1425.285)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13242",
    "data-name": "Path 13242",
    d: "M1791.005,1549.706c1.317.174,3.755.639,5.095.9a1.238,1.238,0,0,1,1,1.178,20.177,20.177,0,0,1-.462,5.013,1.1,1.1,0,0,1-1.307.824l-4.92-1.092a1.21,1.21,0,0,1-.94-1.32l.544-4.73A.882.882,0,0,1,1791.005,1549.706Z",
    transform: "translate(-1770.83 -1502.562)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11360",
    "data-name": "Group 11360",
    transform: "translate(28.058 50.948)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13243",
    "data-name": "Path 13243",
    d: "M1988.116,1629.72a.608.608,0,0,0-.785.574l-.048.82a.918.918,0,0,0,.7.92l11.976,2.524a.755.755,0,0,0,.9-.592l.04-.2a.819.819,0,0,0-.592-.938Z",
    transform: "translate(-1987.282 -1629.697)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13244",
    "data-name": "Path 13244",
    d: "M2354.849,1668.54c1.317.174,3.755.639,5.095.9a1.237,1.237,0,0,1,1,1.178,20.16,20.16,0,0,1-.462,5.013,1.1,1.1,0,0,1-1.307.824l-4.92-1.092a1.211,1.211,0,0,1-.94-1.32l.544-4.73A.882.882,0,0,1,2354.849,1668.54Z",
    transform: "translate(-2307.809 -1615.734)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11361",
    "data-name": "Group 11361",
    transform: "translate(54.923 56.61)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13245",
    "data-name": "Path 13245",
    d: "M2551.96,1748.554a.608.608,0,0,0-.785.574l-.048.82a.918.918,0,0,0,.7.92l11.976,2.524a.755.755,0,0,0,.9-.592l.04-.2a.819.819,0,0,0-.592-.938Z",
    transform: "translate(-2551.125 -1748.531)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11366",
    "data-name": "Group 11366",
    transform: "translate(11.499 59.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13246",
    "data-name": "Path 13246",
    d: "M1774.743,1827l-.012,0-4.541-1a1.25,1.25,0,0,1-1.029-1.3l.4-3.9a.848.848,0,0,1,.327-.583,1.021,1.021,0,0,1,.769-.2h0c.389.055.938.122,1.52.194,1.225.151,2.75.339,3.595.506a1.3,1.3,0,0,1,1.086,1.16,19.507,19.507,0,0,1-.736,4.339A1.149,1.149,0,0,1,1774.743,1827Zm-4.132-6.637a.661.661,0,0,0-.5.124.493.493,0,0,0-.192.338l-.4,3.9a.9.9,0,0,0,.751.918l4.541,1,.009,0a.792.792,0,0,0,.963-.524,19.423,19.423,0,0,0,.727-4.236.96.96,0,0,0-.8-.829c-.833-.165-2.35-.352-3.569-.5-.583-.072-1.135-.14-1.526-.195Z",
    transform: "translate(-1762.988 -1819.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13247",
    "data-name": "Path 13247",
    d: "M1787.448,1837.937c.97.136,3.092.363,4.08.559a.9.9,0,0,1,.753.795,15.8,15.8,0,0,1-.584,3.426.774.774,0,0,1-.946.524l-3.629-.8a.859.859,0,0,1-.711-.888l.323-3.118A.6.6,0,0,1,1787.448,1837.937Z",
    transform: "translate(-1779.419 -1836.314)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11362",
    "data-name": "Group 11362",
    transform: "translate(16.284 4.856)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13248",
    "data-name": "Path 13248",
    d: "M1981.513,1907.162a1.155,1.155,0,0,0,.925,1.074l42.177,8.514a.873.873,0,0,0,.357-1.709l-42.062-9.065A1.155,1.155,0,0,0,1981.513,1907.162Z",
    transform: "translate(-1981.512 -1905.949)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13249",
    "data-name": "Path 13249",
    d: "M1799.5,1806.283h0a.714.714,0,0,1,.908.465l.558,1.8a.229.229,0,0,0,.4.067l3.271-4.487a.254.254,0,0,1,.453.208,10,10,0,0,1-4.282,6.209s-1.225-.8-1.8-3.387A.749.749,0,0,1,1799.5,1806.283Z",
    transform: "translate(-1791.399 -1804.02)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13250",
    "data-name": "Path 13250",
    d: "M1731.6,2031.691l-.012,0-4.541-1a1.25,1.25,0,0,1-1.029-1.3l.4-3.9a.848.848,0,0,1,.327-.583,1.022,1.022,0,0,1,.769-.2h0c.389.055.938.123,1.52.194,1.225.151,2.75.339,3.595.506l.018,0a1.3,1.3,0,0,1,1.068,1.156,19.508,19.508,0,0,1-.736,4.339A1.149,1.149,0,0,1,1731.6,2031.691Zm-4.132-6.636a.661.661,0,0,0-.5.124.493.493,0,0,0-.192.338l-.4,3.9a.894.894,0,0,0,.751.918l4.541,1,.009,0a.792.792,0,0,0,.963-.524,19.422,19.422,0,0,0,.727-4.236.955.955,0,0,0-.8-.83c-.832-.165-2.35-.352-3.569-.5-.583-.072-1.134-.14-1.526-.195Z",
    transform: "translate(-1721.903 -2014.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13251",
    "data-name": "Path 13251",
    d: "M1744.309,2042.627c.97.136,3.092.363,4.08.558a.9.9,0,0,1,.753.795,15.8,15.8,0,0,1-.584,3.426.774.774,0,0,1-.946.524l-3.629-.8a.859.859,0,0,1-.711-.888l.323-3.118A.6.6,0,0,1,1744.309,2042.627Z",
    transform: "translate(-1738.334 -2031.252)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11363",
    "data-name": "Group 11363",
    transform: "translate(14.229 14.609)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13252",
    "data-name": "Path 13252",
    d: "M1938.373,2111.85a1.155,1.155,0,0,0,.925,1.074l42.177,8.514a.873.873,0,0,0,.357-1.709l-42.062-9.065A1.154,1.154,0,0,0,1938.373,2111.85Z",
    transform: "translate(-1938.372 -2110.637)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13253",
    "data-name": "Path 13253",
    d: "M1756.358,2010.971h0a.714.714,0,0,1,.908.465l.558,1.8a.229.229,0,0,0,.4.067l3.271-4.487a.254.254,0,0,1,.453.207,10,10,0,0,1-4.282,6.209s-1.225-.8-1.8-3.387A.749.749,0,0,1,1756.358,2010.971Z",
    transform: "translate(-1750.316 -1998.956)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13254",
    "data-name": "Path 13254",
    d: "M1688.463,2236.38l-.013,0-4.541-1a1.249,1.249,0,0,1-1.029-1.3l.4-3.9a.848.848,0,0,1,.328-.583,1.021,1.021,0,0,1,.769-.2h0c.389.055.938.123,1.52.194,1.225.151,2.75.339,3.595.506l.018,0a1.3,1.3,0,0,1,1.068,1.156,19.51,19.51,0,0,1-.736,4.339A1.149,1.149,0,0,1,1688.463,2236.38Zm-4.131-6.636a.661.661,0,0,0-.5.124.494.494,0,0,0-.192.338l-.4,3.9a.894.894,0,0,0,.751.918l4.541,1,.009,0a.792.792,0,0,0,.963-.524,19.416,19.416,0,0,0,.727-4.236.953.953,0,0,0-.8-.83c-.832-.165-2.35-.352-3.569-.5-.583-.072-1.134-.14-1.526-.195Z",
    transform: "translate(-1680.818 -2209.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13255",
    "data-name": "Path 13255",
    d: "M1701.169,2247.315c.97.136,3.092.363,4.08.558a.9.9,0,0,1,.753.795,15.8,15.8,0,0,1-.584,3.426.773.773,0,0,1-.946.524l-3.629-.8a.858.858,0,0,1-.711-.887l.323-3.118A.6.6,0,0,1,1701.169,2247.315Z",
    transform: "translate(-1697.25 -2226.187)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11364",
    "data-name": "Group 11364",
    transform: "translate(12.173 24.362)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13256",
    "data-name": "Path 13256",
    d: "M1895.234,2316.539a1.155,1.155,0,0,0,.925,1.074l42.177,8.514a.873.873,0,0,0,.357-1.709l-42.062-9.065A1.155,1.155,0,0,0,1895.234,2316.539Z",
    transform: "translate(-1895.232 -2315.326)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13257",
    "data-name": "Path 13257",
    d: "M1713.218,2215.66h0a.714.714,0,0,1,.908.465l.558,1.8a.229.229,0,0,0,.4.067l3.271-4.487a.254.254,0,0,1,.452.208,10,10,0,0,1-4.282,6.209s-1.225-.8-1.8-3.387A.749.749,0,0,1,1713.218,2215.66Z",
    transform: "translate(-1709.231 -2193.892)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13258",
    "data-name": "Path 13258",
    d: "M1645.323,2441.067l-.012,0-4.541-1a1.25,1.25,0,0,1-1.029-1.3l.4-3.9a.849.849,0,0,1,.328-.583,1.021,1.021,0,0,1,.769-.2h0c.389.055.938.122,1.52.194,1.225.151,2.75.339,3.595.506l.018,0a1.3,1.3,0,0,1,1.068,1.156,19.5,19.5,0,0,1-.736,4.339A1.149,1.149,0,0,1,1645.323,2441.067Zm-4.131-6.636a.661.661,0,0,0-.5.124.494.494,0,0,0-.192.338l-.4,3.9a.894.894,0,0,0,.751.918l4.541,1,.009,0a.792.792,0,0,0,.963-.524,19.41,19.41,0,0,0,.727-4.236.951.951,0,0,0-.8-.83c-.832-.165-2.35-.352-3.569-.5-.583-.072-1.134-.14-1.526-.195Z",
    transform: "translate(-1639.734 -2404.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13259",
    "data-name": "Path 13259",
    d: "M1658.03,2452c.97.136,3.092.363,4.08.559a.9.9,0,0,1,.753.795,15.791,15.791,0,0,1-.584,3.426.774.774,0,0,1-.946.524l-3.629-.8a.858.858,0,0,1-.711-.887l.323-3.118A.6.6,0,0,1,1658.03,2452Z",
    transform: "translate(-1656.166 -2421.124)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11365",
    "data-name": "Group 11365",
    transform: "translate(10.118 34.114)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13260",
    "data-name": "Path 13260",
    d: "M1852.094,2521.228h0a1.155,1.155,0,0,0,.925,1.074l42.177,8.514a.873.873,0,0,0,.357-1.71l-42.062-9.065A1.155,1.155,0,0,0,1852.094,2521.228Z",
    transform: "translate(-1852.093 -2520.015)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13261",
    "data-name": "Path 13261",
    d: "M1670.078,2420.349h0a.714.714,0,0,1,.908.465l.558,1.8a.229.229,0,0,0,.4.067l3.271-4.487a.254.254,0,0,1,.453.208,10,10,0,0,1-4.282,6.209s-1.225-.8-1.8-3.387A.749.749,0,0,1,1670.078,2420.349Z",
    transform: "translate(-1668.147 -2388.829)",
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11380",
    "data-name": "Group 11380",
    transform: "translate(461.216 461.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13262",
    "data-name": "Path 13262",
    d: "M486.189,609.437a2.227,2.227,0,0,1,2.034-2.68c8.967-.589,39.721-3.024,64.146-9.968a2.06,2.06,0,0,1,2.56,1.462l23.849,92.061a2.37,2.37,0,0,1-1.686,2.886c-10.31,2.737-52.8,13.853-68.457,15.361a1.878,1.878,0,0,1-2.017-1.487Z",
    transform: "translate(-486.141 -596.709)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13263",
    "data-name": "Path 13263",
    d: "M517.742,663.582A2.143,2.143,0,0,1,519.7,661c8.63-.567,38.225-2.91,61.73-9.593a1.982,1.982,0,0,1,2.464,1.407l22.951,88.594a2.281,2.281,0,0,1-1.623,2.777c-9.922,2.634-50.813,13.332-65.879,14.783a1.807,1.807,0,0,1-1.941-1.431Z",
    transform: "translate(-516.192 -648.731)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13264",
    "data-name": "Path 13264",
    d: "M710.465,916.541l4.792,19.02a1.245,1.245,0,0,0,1.421.924c3.576-.622,14.712-2.6,20.9-4.2a1.391,1.391,0,0,0,1.023-1.58c-.612-3.625-2.48-14.159-4.19-18.374a1.57,1.57,0,0,0-1.715-.955l-21.168,3.534A1.324,1.324,0,0,0,710.465,916.541Z",
    transform: "translate(-699.738 -896.364)",
    fill: "#fff",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_411",
    "data-name": "Ellipse 411",
    cx: 4.212,
    cy: 4.212,
    r: 4.212,
    transform: "matrix(0.068, -0.998, 0.998, 0.068, 19.727, 28.501)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13265",
    "data-name": "Path 13265",
    d: "M888.4,1247.4l13.15-2.671a1.039,1.039,0,0,0,.536-1.743,8.66,8.66,0,0,0-8.354-2.676,9.354,9.354,0,0,0-6.544,5.592A1.086,1.086,0,0,0,888.4,1247.4Z",
    transform: "translate(-867.992 -1209.427)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11368",
    "data-name": "Group 11368",
    transform: "translate(39.763 9.859)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13266",
    "data-name": "Path 13266",
    d: "M1344.585,804.943a.694.694,0,0,0,.6-.792.761.761,0,0,0-.9-.5l-23.132,4.271a.5.5,0,0,0-.359.794l.174.291a1.159,1.159,0,0,0,1.141.5Z",
    transform: "translate(-1320.697 -803.635)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11369",
    "data-name": "Group 11369",
    transform: "translate(40.49 13.439)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13267",
    "data-name": "Path 13267",
    d: "M1336.41,883.048a.5.5,0,0,0-.359.794l.174.291a1.158,1.158,0,0,0,1.141.5l22.478-4.566a.694.694,0,0,0,.6-.792.761.761,0,0,0-.9-.5Z",
    transform: "translate(-1335.956 -878.763)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11370",
    "data-name": "Group 11370",
    transform: "translate(41.228 17.07)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13268",
    "data-name": "Path 13268",
    d: "M1351.891,959.267a.5.5,0,0,0-.359.795l.174.291a1.159,1.159,0,0,0,1.141.5l22.478-4.566a.694.694,0,0,0,.6-.792.761.761,0,0,0-.9-.5Z",
    transform: "translate(-1351.437 -954.982)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11371",
    "data-name": "Group 11371",
    transform: "translate(16.116 34.144)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13269",
    "data-name": "Path 13269",
    d: "M879.187,1314.626a.665.665,0,0,0,.575-.788.786.786,0,0,0-.923-.489l-54.083,10.542c-.412.08-.487.367-.165.637l.554.465a1.8,1.8,0,0,0,1.334.339Z",
    transform: "translate(-824.39 -1313.333)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11372",
    "data-name": "Group 11372",
    transform: "translate(16.843 37.724)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13270",
    "data-name": "Path 13270",
    d: "M840.014,1399.019c-.413.08-.487.367-.165.637l.554.464a1.8,1.8,0,0,0,1.334.339l52.708-10.705a.665.665,0,0,0,.575-.788.786.786,0,0,0-.923-.489Z",
    transform: "translate(-839.649 -1388.46)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13271",
    "data-name": "Path 13271",
    d: "M854.892,1712.1c1.278-.363,3.7-.9,5.034-1.194a1.238,1.238,0,0,1,1.386.684,20.175,20.175,0,0,1,1.565,4.784,1.1,1.1,0,0,1-.873,1.275l-4.949.95a1.21,1.21,0,0,1-1.387-.838l-1.378-4.558A.882.882,0,0,1,854.892,1712.1Z",
    transform: "translate(-836.714 -1657.795)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11373",
    "data-name": "Group 11373",
    transform: "translate(27.162 52.364)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13272",
    "data-name": "Path 13272",
    d: "M1056.762,1697.733a.608.608,0,0,0-.493.839l.281.772a.918.918,0,0,0,1.01.566l11.995-2.436a.755.755,0,0,0,.587-.9l-.044-.2a.818.818,0,0,0-.916-.626Z",
    transform: "translate(-1056.226 -1695.737)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13273",
    "data-name": "Path 13273",
    d: "M1419.593,1597.408c1.278-.363,3.7-.9,5.034-1.194a1.238,1.238,0,0,1,1.386.684,20.175,20.175,0,0,1,1.565,4.785,1.1,1.1,0,0,1-.873,1.275l-4.949.95a1.21,1.21,0,0,1-1.386-.838l-1.378-4.558A.881.881,0,0,1,1419.593,1597.408Z",
    transform: "translate(-1374.509 -1548.564)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11374",
    "data-name": "Group 11374",
    transform: "translate(54.068 46.899)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13274",
    "data-name": "Path 13274",
    d: "M1621.463,1583.038a.608.608,0,0,0-.493.839l.281.772a.918.918,0,0,0,1.01.566l11.995-2.436a.755.755,0,0,0,.587-.9l-.044-.2a.818.818,0,0,0-.916-.626Z",
    transform: "translate(-1620.926 -1581.042)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11379",
    "data-name": "Group 11379",
    transform: "translate(21.635 57.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13275",
    "data-name": "Path 13275",
    d: "M947.467,1969.477l-.012,0-4.566.882a1.25,1.25,0,0,1-1.462-.788l-1.177-3.742a.848.848,0,0,1,.069-.665,1.02,1.02,0,0,1,.627-.486h0c.379-.1.91-.26,1.473-.425,1.184-.347,2.659-.78,3.5-.962a1.3,1.3,0,0,1,1.458.634,19.5,19.5,0,0,1,1.047,4.274A1.149,1.149,0,0,1,947.467,1969.477Zm-6.426-4.452a.661.661,0,0,0-.409.312.493.493,0,0,0-.042.386l1.177,3.742a.894.894,0,0,0,1.054.545l4.566-.882.009,0a.792.792,0,0,0,.676-.863,19.413,19.413,0,0,0-1.014-4.177.959.959,0,0,0-1.063-.444c-.829.179-2.3.61-3.475.955-.564.166-1.1.322-1.478.427Z",
    transform: "translate(-940.211 -1956.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13276",
    "data-name": "Path 13276",
    d: "M959.955,1983.887c.944-.26,2.982-.894,3.966-1.106a.9.9,0,0,1,1.007.431,15.809,15.809,0,0,1,.823,3.377.774.774,0,0,1-.661.856l-3.649.7a.859.859,0,0,1-1.005-.533l-.941-2.99A.6.6,0,0,1,959.955,1983.887Z",
    transform: "translate(-958.554 -1974.66)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11375",
    "data-name": "Group 11375",
    transform: "translate(10.623)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13277",
    "data-name": "Path 13277",
    d: "M1163.295,1822.835a1.154,1.154,0,0,0,1.275.619l42.093-8.924a.873.873,0,0,0-.351-1.711l-42.206,8.372A1.155,1.155,0,0,0,1163.295,1822.835Z",
    transform: "translate(-1163.175 -1812.803)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13278",
    "data-name": "Path 13278",
    d: "M989.1,2174.451l-.013,0-4.566.882a1.25,1.25,0,0,1-1.462-.788l-1.177-3.742a.847.847,0,0,1,.069-.665,1.022,1.022,0,0,1,.627-.486h0c.379-.1.91-.26,1.473-.425,1.184-.347,2.659-.78,3.5-.962l.018,0a1.3,1.3,0,0,1,1.439.637,19.5,19.5,0,0,1,1.047,4.274A1.149,1.149,0,0,1,989.1,2174.451ZM982.678,2170a.662.662,0,0,0-.409.312.493.493,0,0,0-.042.387l1.177,3.742a.9.9,0,0,0,1.054.545l4.566-.882.009,0a.792.792,0,0,0,.676-.863,19.41,19.41,0,0,0-1.014-4.177.955.955,0,0,0-1.063-.444c-.829.179-2.3.61-3.475.956-.564.166-1.1.322-1.478.427Z",
    transform: "translate(-979.864 -2151.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13279",
    "data-name": "Path 13279",
    d: "M1001.592,2188.887c.944-.26,2.982-.894,3.966-1.106a.9.9,0,0,1,1.007.431,15.8,15.8,0,0,1,.823,3.377.774.774,0,0,1-.661.856l-3.649.7a.859.859,0,0,1-1.005-.533l-.941-2.99A.6.6,0,0,1,1001.592,2188.887Z",
    transform: "translate(-998.207 -2169.892)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11376",
    "data-name": "Group 11376",
    transform: "translate(12.607 9.767)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13280",
    "data-name": "Path 13280",
    d: "M1204.932,2027.835a1.154,1.154,0,0,0,1.275.619l42.093-8.924a.873.873,0,0,0-.351-1.711l-42.206,8.372A1.155,1.155,0,0,0,1204.932,2027.835Z",
    transform: "translate(-1204.812 -2017.803)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13281",
    "data-name": "Path 13281",
    d: "M1030.742,2379.449l-.013,0-4.566.882a1.249,1.249,0,0,1-1.462-.788l-1.177-3.742a.849.849,0,0,1,.069-.665,1.022,1.022,0,0,1,.627-.486h0c.379-.1.91-.26,1.472-.425,1.184-.347,2.659-.78,3.5-.962l.018,0a1.3,1.3,0,0,1,1.439.637,19.507,19.507,0,0,1,1.047,4.274A1.149,1.149,0,0,1,1030.742,2379.449Zm-6.426-4.452a.661.661,0,0,0-.409.312.493.493,0,0,0-.042.387l1.177,3.742a.894.894,0,0,0,1.053.544l4.566-.882.009,0a.793.793,0,0,0,.676-.863,19.4,19.4,0,0,0-1.015-4.177.953.953,0,0,0-1.062-.444c-.829.179-2.3.61-3.475.956-.564.166-1.1.322-1.478.427Z",
    transform: "translate(-1019.518 -2346.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13282",
    "data-name": "Path 13282",
    d: "M1043.229,2393.886c.944-.26,2.982-.894,3.966-1.107a.9.9,0,0,1,1.007.431,15.81,15.81,0,0,1,.823,3.377.773.773,0,0,1-.66.856l-3.649.7a.858.858,0,0,1-1.005-.532l-.941-2.991A.6.6,0,0,1,1043.229,2393.886Z",
    transform: "translate(-1037.86 -2365.124)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11377",
    "data-name": "Group 11377",
    transform: "translate(14.591 19.535)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13283",
    "data-name": "Path 13283",
    d: "M1246.569,2232.835a1.154,1.154,0,0,0,1.275.618l42.093-8.923a.873.873,0,0,0-.351-1.711l-42.206,8.372A1.155,1.155,0,0,0,1246.569,2232.835Z",
    transform: "translate(-1246.449 -2222.802)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13284",
    "data-name": "Path 13284",
    d: "M1072.379,2584.449l-.013,0-4.566.882a1.25,1.25,0,0,1-1.462-.788l-1.177-3.742a.849.849,0,0,1,.069-.665,1.02,1.02,0,0,1,.627-.486h0c.379-.1.91-.26,1.473-.425,1.184-.347,2.659-.78,3.5-.962l.018,0a1.3,1.3,0,0,1,1.439.637,19.492,19.492,0,0,1,1.047,4.275A1.149,1.149,0,0,1,1072.379,2584.449Zm-6.426-4.452a.66.66,0,0,0-.409.312.494.494,0,0,0-.042.387l1.177,3.742a.894.894,0,0,0,1.054.544l4.566-.882.009,0a.792.792,0,0,0,.676-.863,19.428,19.428,0,0,0-1.014-4.177.952.952,0,0,0-1.063-.444c-.829.179-2.3.61-3.475.956-.564.166-1.1.322-1.478.427Z",
    transform: "translate(-1059.171 -2541.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13285",
    "data-name": "Path 13285",
    d: "M1084.866,2598.886c.944-.26,2.982-.894,3.966-1.106a.9.9,0,0,1,1.007.43,15.8,15.8,0,0,1,.823,3.377.773.773,0,0,1-.661.856l-3.649.7a.858.858,0,0,1-1.005-.532l-.941-2.991A.6.6,0,0,1,1084.866,2598.886Z",
    transform: "translate(-1077.514 -2560.356)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11378",
    "data-name": "Group 11378",
    transform: "translate(16.575 29.302)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13286",
    "data-name": "Path 13286",
    d: "M1288.206,2437.834h0a1.155,1.155,0,0,0,1.275.619l42.093-8.924a.873.873,0,0,0-.351-1.711l-42.206,8.372A1.155,1.155,0,0,0,1288.206,2437.834Z",
    transform: "translate(-1288.087 -2427.802)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13287",
    "data-name": "Path 13287",
    d: "M1096.194,2548.916h0a.714.714,0,0,1,1.018.067l1.226,1.429a.229.229,0,0,0,.4-.1l1.221-5.417a.254.254,0,0,1,.5.011,10,10,0,0,1-1.466,7.4s-1.442-.248-3-2.394A.749.749,0,0,1,1096.194,2548.916Z",
    transform: "translate(-1088.527 -2509.826)",
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11383",
    "data-name": "Group 11383",
    transform: "translate(459.969 513.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11381",
    "data-name": "Group 11381",
    transform: "translate(2.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13288",
    "data-name": "Path 13288",
    d: "M544.356,1718.471a121.867,121.867,0,0,0,2.579,15.181h.741a82.84,82.84,0,0,1-2.515-23.807c.417-9.6,2.768-21.255-1.616-26.823-3.649-4.634-19.131-5.327-24.223-5.429a.751.751,0,0,0-.6,1.218c1.952,2.456,6.039,8.144,6.4,13.111.469,6.546,5.557,11.685,10.613,13.824S543.5,1709.517,544.356,1718.471Z",
    transform: "translate(-518.552 -1677.594)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13289",
    "data-name": "Path 13289",
    d: "M665.5,1762.46a24.412,24.412,0,0,1,8.685,4.18,19.1,19.1,0,0,1,3.489,3.4,16.519,16.519,0,0,1,2.432,4.239l.217.574c.071.192.124.39.187.585s.123.392.174.586l.155.582q.312,1.163.609,2.33.592,2.334,1.111,4.687c.693,3.136,1.289,6.292,1.692,9.484a.14.14,0,0,1-.276.043v0c-.286-1.571-.6-3.142-.948-4.7s-.7-3.124-1.071-4.679l-.57-2.331-.6-2.325q-.3-1.163-.614-2.32l-.156-.579c-.052-.193-.114-.377-.17-.565s-.108-.377-.175-.561l-.2-.552a16.4,16.4,0,0,0-2.3-4.089,18.126,18.126,0,0,0-1.56-1.773l-.208-.211-.216-.2c-.144-.134-.286-.273-.433-.4-.3-.259-.594-.522-.906-.765a24.485,24.485,0,0,0-3.99-2.579,25.47,25.47,0,0,0-4.4-1.824l-.007,0a.112.112,0,0,1,.06-.216Z",
    transform: "translate(-658.367 -1758.413)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11382",
    "data-name": "Group 11382",
    transform: "translate(0 30.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13290",
    "data-name": "Path 13290",
    d: "M488.71,2336.677a11.85,11.85,0,0,1,2.389,7.906c.014.327.032.789.07,1.336h.723a15.856,15.856,0,0,1-.29-2.248c-.258-5.088-1.405-13.773-5.794-18.969s-9.193-5.669-15.248-.946c-5.046,3.936-8.193,5.922-10.039,6.291a.7.7,0,0,0-.468,1.017c1.184,2.18,4.531,7.188,10.151,6.835C477.374,2337.449,486.062,2332.789,488.71,2336.677Z",
    transform: "translate(-459.969 -2320.49)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13291",
    "data-name": "Path 13291",
    d: "M724.629,2444.67a14.4,14.4,0,0,1,1.25-1.046c.433-.327.88-.639,1.345-.923a13.468,13.468,0,0,1,2.969-1.4,9.321,9.321,0,0,1,1.624-.365,6.954,6.954,0,0,1,1.684-.007c.14.023.281.036.42.067s.28.059.414.1l.79.245.773.3.75.36a9.439,9.439,0,0,1,2.611,2.042,11.725,11.725,0,0,1,1.808,2.75l.18.368c.062.122.107.251.161.376.1.253.212.5.307.758l.266.771c.094.255.154.521.23.781a28.456,28.456,0,0,1,.686,3.171.109.109,0,0,1-.214.044v0c-.252-1.043-.5-2.088-.843-3.1-.157-.51-.357-1-.543-1.5-.1-.246-.214-.486-.32-.729-.056-.12-.1-.245-.167-.361l-.185-.351a11.945,11.945,0,0,0-1.791-2.584,9.184,9.184,0,0,0-2.473-1.887l-.707-.335-.732-.28-.752-.229c-.125-.035-.247-.059-.371-.089s-.251-.041-.376-.063a6.3,6.3,0,0,0-1.535,0,8.766,8.766,0,0,0-1.527.31,14.67,14.67,0,0,0-2.908,1.239c-.464.258-.924.528-1.37.82s-.885.6-1.3.926l0,0a.113.113,0,0,1-.148-.172Z",
    transform: "translate(-711.986 -2435.148)",
    fill: "#fff",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11397",
    "data-name": "Group 11397",
    transform: "translate(488.859 463.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13292",
    "data-name": "Path 13292",
    d: "M1066.328,917.7a7.213,7.213,0,0,1,7.213-7.213h61.337a6.354,6.354,0,0,1,6.346,6.031l4.528,88.928a4.686,4.686,0,0,1-4.595,4.923l-70.3,1.278a4.448,4.448,0,0,1-4.529-4.447Z",
    transform: "translate(-1066.328 -897.017)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11396",
    "data-name": "Group 11396",
    transform: "translate(5.025 12.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13293",
    "data-name": "Path 13293",
    d: "M1171.794,897.058a2.1,2.1,0,0,1,2.376-2.09c8.376,1.136,37.18,4.649,60.994,2.821a1.938,1.938,0,0,1,2.086,1.827L1242,988.941a2.229,2.229,0,0,1-2.094,2.345c-10.016.593-51.264,2.884-65.977,1.343a1.766,1.766,0,0,1-1.58-1.748Z",
    transform: "translate(-1171.794 -894.949)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13294",
    "data-name": "Path 13294",
    d: "M1192.5,945.626a2.016,2.016,0,0,1,2.287-2.011c8.061,1.093,35.78,4.474,58.7,2.715a1.864,1.864,0,0,1,2.008,1.758l4.569,85.961a2.146,2.146,0,0,1-2.016,2.256c-9.639.57-49.334,2.775-63.493,1.292a1.7,1.7,0,0,1-1.521-1.682Z",
    transform: "translate(-1191.516 -941.279)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13295",
    "data-name": "Path 13295",
    d: "M1349.09,1099.236l.856,18.429a1.171,1.171,0,0,0,1.137,1.118c3.413.1,14.048.356,20.053.043a1.309,1.309,0,0,0,1.239-1.265c.114-3.456.365-13.516-.422-17.721a1.477,1.477,0,0,0-1.4-1.2l-20.174-.705A1.246,1.246,0,0,0,1349.09,1099.236Z",
    transform: "translate(-1340.641 -1088.261)",
    fill: "#fff",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_412",
    "data-name": "Ellipse 412",
    cx: 3.962,
    cy: 3.962,
    r: 3.962,
    transform: "translate(15.291 20.509) rotate(-76.717)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13296",
    "data-name": "Path 13296",
    d: "M1446.017,1396.949h12.621a.977.977,0,0,0,.821-1.507,8.145,8.145,0,0,0-7.2-4.031,8.8,8.8,0,0,0-7.079,3.93A1.021,1.021,0,0,0,1446.017,1396.949Z",
    transform: "translate(-1431.977 -1367.753)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11384",
    "data-name": "Group 11384",
    transform: "translate(36.244 10.935)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13297",
    "data-name": "Path 13297",
    d: "M1955.166,1126.108a.653.653,0,0,0,.7-.618.716.716,0,0,0-.737-.631l-22.122-.394a.467.467,0,0,0-.48.665l.106.3a1.09,1.09,0,0,0,.958.678Z",
    transform: "translate(-1932.49 -1124.464)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11385",
    "data-name": "Group 11385",
    transform: "translate(36.244 14.371)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13298",
    "data-name": "Path 13298",
    d: "M1933.008,1196.572a.467.467,0,0,0-.48.665l.106.3a1.09,1.09,0,0,0,.958.678h21.574a.653.653,0,0,0,.7-.618.716.716,0,0,0-.737-.631Z",
    transform: "translate(-1932.49 -1196.571)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11386",
    "data-name": "Group 11386",
    transform: "translate(36.244 17.857)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13299",
    "data-name": "Path 13299",
    d: "M1933.008,1269.728a.467.467,0,0,0-.48.665l.106.3a1.089,1.089,0,0,0,.958.678h21.574a.653.653,0,0,0,.7-.618.716.716,0,0,0-.737-.631Z",
    transform: "translate(-1932.49 -1269.727)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11387",
    "data-name": "Group 11387",
    transform: "translate(8.763 34.659)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13300",
    "data-name": "Path 13300",
    d: "M1408.022,1624.024a.625.625,0,0,0,.678-.618.739.739,0,0,0-.759-.624l-51.826-.409c-.4,0-.517.247-.271.557l.423.532a1.692,1.692,0,0,0,1.166.562Z",
    transform: "translate(-1355.716 -1622.373)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11388",
    "data-name": "Group 11388",
    transform: "translate(8.763 38.094)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13301",
    "data-name": "Path 13301",
    d: "M1356.114,1694.48c-.4,0-.517.247-.271.557l.423.532a1.692,1.692,0,0,0,1.166.562h50.589a.625.625,0,0,0,.678-.618.739.739,0,0,0-.759-.624Z",
    transform: "translate(-1355.716 -1694.48)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13302",
    "data-name": "Path 13302",
    d: "M1343.884,1811.72c1.246-.1,3.58-.14,4.864-.158a1.164,1.164,0,0,1,1.149.89,18.982,18.982,0,0,1,.547,4.7,1.034,1.034,0,0,1-1.043,1.012l-4.74-.051a1.138,1.138,0,0,1-1.121-1.032l-.417-4.459A.83.83,0,0,1,1343.884,1811.72Z",
    transform: "translate(-1334.956 -1767.89)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11389",
    "data-name": "Group 11389",
    transform: "translate(17.074 45.661)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13303",
    "data-name": "Path 13303",
    d: "M1530.77,1853.294a.572.572,0,0,0-.611.681l.115.764a.863.863,0,0,0,.825.711h11.512a.71.71,0,0,0,.71-.719l0-.194a.77.77,0,0,0-.727-.749Z",
    transform: "translate(-1530.15 -1853.294)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13304",
    "data-name": "Path 13304",
    d: "M1885.88,1811.72c1.246-.1,3.58-.14,4.864-.158a1.164,1.164,0,0,1,1.149.89,18.982,18.982,0,0,1,.547,4.7,1.034,1.034,0,0,1-1.043,1.012l-4.74-.051a1.138,1.138,0,0,1-1.121-1.032l-.417-4.459A.83.83,0,0,1,1885.88,1811.72Z",
    transform: "translate(-1851.129 -1767.89)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11390",
    "data-name": "Group 11390",
    transform: "translate(42.898 45.661)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13305",
    "data-name": "Path 13305",
    d: "M2072.766,1853.294a.572.572,0,0,0-.611.681l.115.764a.863.863,0,0,0,.825.711h11.512a.71.71,0,0,0,.709-.719l0-.194a.77.77,0,0,0-.727-.749Z",
    transform: "translate(-2072.147 -1853.294)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11395",
    "data-name": "Group 11395",
    transform: "translate(9.641 54.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13306",
    "data-name": "Path 13306",
    d: "M1380.114,2066.491h-.012l-4.374-.042a1.176,1.176,0,0,1-1.2-1l-.385-3.67a.8.8,0,0,1,.188-.6.96.96,0,0,1,.669-.33h0c.368-.025.887-.069,1.437-.116,1.157-.1,2.6-.221,3.407-.231a1.223,1.223,0,0,1,1.225.857,18.345,18.345,0,0,1,.165,4.136A1.081,1.081,0,0,1,1380.114,2066.491Zm-5.09-5.307a.623.623,0,0,0-.435.211.464.464,0,0,0-.111.349l.384,3.67a.842.842,0,0,0,.869.7l4.374.042h.009a.745.745,0,0,0,.784-.669,18.264,18.264,0,0,0-.153-4.04.9.9,0,0,0-.9-.608c-.8.01-2.231.132-3.382.23-.551.047-1.071.091-1.442.116Z",
    transform: "translate(-1374.139 -2059.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13307",
    "data-name": "Path 13307",
    d: "M1391.318,2077.232c.919-.062,2.916-.266,3.863-.277a.847.847,0,0,1,.847.586,14.863,14.863,0,0,1,.127,3.267.727.727,0,0,1-.769.666l-3.5-.033a.807.807,0,0,1-.827-.679l-.307-2.933A.568.568,0,0,1,1391.318,2077.232Z",
    transform: "translate(-1389.963 -2074.684)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11391",
    "data-name": "Group 11391",
    transform: "translate(9.78 3.676)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13308",
    "data-name": "Path 13308",
    d: "M1579.442,2107.818a1.086,1.086,0,0,0,1.059.809l40.47-.345a.821.821,0,0,0,0-1.643l-40.472-.184A1.086,1.086,0,0,0,1579.442,2107.818Z",
    transform: "translate(-1579.406 -2106.455)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13309",
    "data-name": "Path 13309",
    d: "M1399.57,2032.421h0a.671.671,0,0,1,.926.252l.863,1.547a.216.216,0,0,0,.385-.017l2.14-4.764a.239.239,0,0,1,.457.1,9.407,9.407,0,0,1-2.737,6.546,5.115,5.115,0,0,1-2.317-2.768A.7.7,0,0,1,1399.57,2032.421Z",
    transform: "translate(-1398.028 -2029.297)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13310",
    "data-name": "Path 13310",
    d: "M1380.114,2263.246h-.012l-4.374-.042a1.176,1.176,0,0,1-1.2-1l-.385-3.67a.8.8,0,0,1,.188-.6.961.961,0,0,1,.669-.331h0c.368-.025.887-.069,1.437-.116,1.157-.1,2.6-.221,3.407-.231h.017a1.22,1.22,0,0,1,1.207.857,18.342,18.342,0,0,1,.165,4.136A1.081,1.081,0,0,1,1380.114,2263.246Zm-5.09-5.307a.621.621,0,0,0-.435.211.463.463,0,0,0-.111.348l.384,3.67a.841.841,0,0,0,.869.7l4.374.042h.009a.745.745,0,0,0,.784-.669,18.261,18.261,0,0,0-.153-4.04.9.9,0,0,0-.9-.608c-.8.01-2.231.132-3.382.23-.551.047-1.071.091-1.442.117Z",
    transform: "translate(-1374.139 -2246.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13311",
    "data-name": "Path 13311",
    d: "M1391.318,2273.99c.919-.062,2.916-.266,3.863-.277a.847.847,0,0,1,.847.585,14.869,14.869,0,0,1,.127,3.267.728.728,0,0,1-.769.666l-3.5-.034a.808.808,0,0,1-.827-.679l-.307-2.933A.568.568,0,0,1,1391.318,2273.99Z",
    transform: "translate(-1389.963 -2262.067)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11392",
    "data-name": "Group 11392",
    transform: "translate(9.78 13.051)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13312",
    "data-name": "Path 13312",
    d: "M1579.442,2304.576a1.087,1.087,0,0,0,1.059.809l40.47-.345a.821.821,0,0,0,0-1.642l-40.472-.185A1.086,1.086,0,0,0,1579.442,2304.576Z",
    transform: "translate(-1579.406 -2303.213)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13313",
    "data-name": "Path 13313",
    d: "M1399.57,2229.178h0a.671.671,0,0,1,.926.252l.863,1.547a.216.216,0,0,0,.385-.017l2.14-4.764a.239.239,0,0,1,.457.1,9.407,9.407,0,0,1-2.737,6.546,5.115,5.115,0,0,1-2.317-2.768A.7.7,0,0,1,1399.57,2229.178Z",
    transform: "translate(-1398.028 -2216.68)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13314",
    "data-name": "Path 13314",
    d: "M1380.114,2460h-.012l-4.374-.042a1.175,1.175,0,0,1-1.2-1l-.385-3.67a.8.8,0,0,1,.188-.6.961.961,0,0,1,.669-.33h0c.368-.025.887-.069,1.437-.116,1.157-.1,2.6-.221,3.407-.231h.017a1.22,1.22,0,0,1,1.207.857,18.343,18.343,0,0,1,.165,4.136A1.081,1.081,0,0,1,1380.114,2460Zm-5.09-5.307a.62.62,0,0,0-.435.211.463.463,0,0,0-.111.349l.384,3.67a.841.841,0,0,0,.869.7l4.374.042h.009a.745.745,0,0,0,.784-.669,18.263,18.263,0,0,0-.153-4.04.9.9,0,0,0-.9-.608c-.8.01-2.231.132-3.382.23-.551.047-1.071.091-1.442.117Z",
    transform: "translate(-1374.139 -2433.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13315",
    "data-name": "Path 13315",
    d: "M1391.318,2470.747c.919-.062,2.916-.265,3.863-.277a.847.847,0,0,1,.847.586,14.863,14.863,0,0,1,.127,3.267.728.728,0,0,1-.769.666l-3.5-.034a.807.807,0,0,1-.827-.679l-.307-2.933A.568.568,0,0,1,1391.318,2470.747Z",
    transform: "translate(-1389.963 -2449.449)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11393",
    "data-name": "Group 11393",
    transform: "translate(9.78 22.426)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13316",
    "data-name": "Path 13316",
    d: "M1579.442,2501.334a1.086,1.086,0,0,0,1.059.809l40.47-.345a.821.821,0,0,0,0-1.642l-40.472-.185A1.086,1.086,0,0,0,1579.442,2501.334Z",
    transform: "translate(-1579.406 -2499.971)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13317",
    "data-name": "Path 13317",
    d: "M1399.57,2425.936h0a.671.671,0,0,1,.926.252l.863,1.546a.216.216,0,0,0,.385-.017l2.14-4.764a.239.239,0,0,1,.457.1,9.407,9.407,0,0,1-2.737,6.546,5.113,5.113,0,0,1-2.317-2.768A.7.7,0,0,1,1399.57,2425.936Z",
    transform: "translate(-1398.028 -2404.063)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13318",
    "data-name": "Path 13318",
    d: "M1380.114,2656.761h-.012l-4.374-.042a1.175,1.175,0,0,1-1.2-1l-.385-3.67a.8.8,0,0,1,.188-.6.96.96,0,0,1,.669-.33h0c.368-.025.887-.07,1.437-.116,1.157-.1,2.6-.221,3.407-.231h.017a1.22,1.22,0,0,1,1.207.857,18.343,18.343,0,0,1,.165,4.136A1.081,1.081,0,0,1,1380.114,2656.761Zm-5.09-5.307a.622.622,0,0,0-.435.211.464.464,0,0,0-.111.349l.384,3.67a.841.841,0,0,0,.869.7l4.374.042h.009a.745.745,0,0,0,.784-.669,18.263,18.263,0,0,0-.153-4.04.9.9,0,0,0-.9-.608c-.8.01-2.231.132-3.382.23-.551.047-1.071.091-1.442.116Z",
    transform: "translate(-1374.139 -2621.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13319",
    "data-name": "Path 13319",
    d: "M1391.318,2667.5c.919-.063,2.916-.266,3.863-.277a.846.846,0,0,1,.847.585,14.866,14.866,0,0,1,.127,3.267.728.728,0,0,1-.769.666l-3.5-.033a.808.808,0,0,1-.827-.679l-.307-2.933A.568.568,0,0,1,1391.318,2667.5Z",
    transform: "translate(-1389.963 -2636.833)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11394",
    "data-name": "Group 11394",
    transform: "translate(9.78 31.8)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13320",
    "data-name": "Path 13320",
    d: "M1579.442,2698.092h0a1.086,1.086,0,0,0,1.059.809l40.47-.345a.821.821,0,0,0,0-1.643l-40.472-.184A1.086,1.086,0,0,0,1579.442,2698.092Z",
    transform: "translate(-1579.406 -2696.729)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13321",
    "data-name": "Path 13321",
    d: "M1399.57,2622.694h0a.671.671,0,0,1,.926.252l.863,1.547a.216.216,0,0,0,.385-.017l2.14-4.764a.239.239,0,0,1,.457.1,9.407,9.407,0,0,1-2.737,6.546,5.115,5.115,0,0,1-2.317-2.768A.7.7,0,0,1,1399.57,2622.694Z",
    transform: "translate(-1398.028 -2591.447)",
    fill: "#6a75b9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13322",
    "data-name": "Path 13322",
    d: "M1792.7,629.153a6.231,6.231,0,0,0-5.5-1.111,2.705,2.705,0,0,0-1.921,2.844l.585,6.384,6.96.618S1797.048,632.176,1792.7,629.153Zm-3.06,5.15a1.735,1.735,0,1,1,1.735-1.735A1.735,1.735,0,0,1,1789.642,634.3Z",
    transform: "translate(-1751.017 -627.809)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13323",
    "data-name": "Path 13323",
    d: "M1803.76,653.268a.168.168,0,0,1-.167-.153l-.093-1.017a.168.168,0,1,1,.334-.03l.093,1.017a.168.168,0,0,1-.152.183Zm-.183-1.992a.168.168,0,0,1-.167-.153l-.071-.772a2.582,2.582,0,0,1,1.831-2.709,5.2,5.2,0,0,1,2.543-.1.168.168,0,0,1-.067.329,4.875,4.875,0,0,0-2.381.1,2.246,2.246,0,0,0-1.591,2.357l.071.772a.168.168,0,0,1-.152.183Z",
    transform: "translate(-1768.214 -646.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13324",
    "data-name": "Path 13324",
    d: "M1598.432,809.651v-3.209a1.959,1.959,0,0,1,2.026-1.957l22.128.758a1.9,1.9,0,0,1,1.836,1.79l.185,3.084Z",
    transform: "translate(-1573.079 -796.065)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13325",
    "data-name": "Path 13325",
    d: "M1749.228,823.176h-.952a.168.168,0,1,1,0-.336h.952a.168.168,0,1,1,0,.336Z",
    transform: "translate(-1715.624 -813.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13326",
    "data-name": "Path 13326",
    d: "M1620.213,826.126a.168.168,0,0,1-.168-.168v-1.3a1.821,1.821,0,0,1,1.819-1.819h3.5a.168.168,0,0,1,0,.336h-3.5a1.485,1.485,0,0,0-1.483,1.483v1.3A.168.168,0,0,1,1620.213,826.126Z",
    transform: "translate(-1593.663 -813.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13327",
    "data-name": "Path 13327",
    d: "M2062.5,983.453l-5.209-4.248-5.209,4.248a89.261,89.261,0,0,0,.389-13.29q-.105-2.311-.317-4.474a.66.66,0,0,1,.657-.722h9.064a.659.659,0,0,1,.658.624q.174,3.32.216,6.866C2062.79,976.311,2062.694,979.983,2062.5,983.453Z",
    transform: "translate(-2005.114 -948.903)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13328",
    "data-name": "Path 13328",
    d: "M1407.453,890.26a2.085,2.085,0,0,1,2.083-1.985h38.695a2.86,2.86,0,0,1,2.818,2.372l.033.189a2.456,2.456,0,0,1-2.42,2.875h-39.7a1.6,1.6,0,0,1-1.6-1.674Z",
    transform: "translate(-1391.117 -875.864)",
    fill: "#6a75b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11398",
    "data-name": "Group 11398",
    transform: "translate(478.636 502.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13329",
    "data-name": "Path 13329",
    d: "M1054.207,1446.739l-.75.951,0,0a.16.16,0,0,1-.25-.2l0,0,.779-.939a.145.145,0,0,1,.226.183Z",
    transform: "translate(-1043.572 -1446.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13330",
    "data-name": "Path 13330",
    d: "M988.041,1517.941l-1.272,2.03-.006.01a.22.22,0,0,1-.373-.234l0,0,1.323-2.023a.2.2,0,0,1,.331.212Z",
    transform: "translate(-979.943 -1514.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13331",
    "data-name": "Path 13331",
    d: "M933.239,1616.109l-1.02,2.164-.006.013a.269.269,0,1,1-.486-.229l0,0,1.071-2.17a.247.247,0,0,1,.446.214Z",
    transform: "translate(-927.892 -1607.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13332",
    "data-name": "Path 13332",
    d: "M891.424,1720.686l-.741,2.271-.006.017a.317.317,0,1,1-.6-.2l0-.005.792-2.291a.3.3,0,0,1,.561.188Z",
    transform: "translate(-888.233 -1707.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13333",
    "data-name": "Path 13333",
    d: "M864.242,1830.367l-.442,2.345,0,.021a.353.353,0,1,1-.695-.131v0l.475-2.38a.34.34,0,0,1,.668.129Z",
    transform: "translate(-862.555 -1811.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13334",
    "data-name": "Path 13334",
    d: "M852.636,1943.719l-.117,2.38v.023a.383.383,0,1,1-.766-.038v0l.145-2.425a.37.37,0,0,1,.739.04Z",
    transform: "translate(-851.752 -1919.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13335",
    "data-name": "Path 13335",
    d: "M853.141,2058.415l.211,2.373,0,.024a.413.413,0,1,1-.823.073v0l-.189-2.424a.4.4,0,0,1,.8-.067Z",
    transform: "translate(-852.313 -2028.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13336",
    "data-name": "Path 13336",
    d: "M866.576,2172.268l.533,2.32.006.025a.443.443,0,0,1-.863.2v0l-.519-2.377a.43.43,0,0,1,.839-.188Z",
    transform: "translate(-865.056 -2137.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13337",
    "data-name": "Path 13337",
    d: "M895.44,2283.129l.832,2.23.009.025a.466.466,0,1,1-.873.325v0l-.839-2.284a.46.46,0,1,1,.863-.317Z",
    transform: "translate(-892.501 -2242.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13338",
    "data-name": "Path 13338",
    d: "M939.173,2389.51l1.112,2.1.012.023a.476.476,0,1,1-.841.444v0l-1.129-2.155a.471.471,0,0,1,.835-.437Z",
    transform: "translate(-934.151 -2344.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13339",
    "data-name": "Path 13339",
    d: "M996.248,2489.417l1.368,1.948.015.021a.485.485,0,1,1-.795.558h0l-1.391-2a.481.481,0,0,1,.789-.55Z",
    transform: "translate(-988.516 -2439.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13340",
    "data-name": "Path 13340",
    d: "M1065.407,2581.357l1.6,1.761.018.02a.5.5,0,1,1-.733.666h0l-1.63-1.807a.491.491,0,0,1,.729-.658Z",
    transform: "translate(-1054.396 -2527.114)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13341",
    "data-name": "Path 13341",
    d: "M1145.611,2663.8l1.814,1.535.023.02a.505.505,0,1,1-.653.771h0l-1.854-1.581a.5.5,0,1,1,.65-.762Z",
    transform: "translate(-1130.803 -2605.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13342",
    "data-name": "Path 13342",
    d: "M1236.132,2734.708l1.006.627.5.314c.169.1.333.213.505.309a.515.515,0,1,1-.5.9h0l-.014-.007c-.178-.1-.347-.214-.52-.32l-.517-.325-1.034-.65a.51.51,0,0,1,.544-.864Z",
    transform: "translate(-1217.048 -2673.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13343",
    "data-name": "Path 13343",
    d: "M1336.724,2790.98q1.077.492,2.187.911a.518.518,0,0,1-.364.97q-1.143-.428-2.256-.934a.521.521,0,1,1,.433-.947Z",
    transform: "translate(-1312.915 -2726.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13344",
    "data-name": "Path 13344",
    d: "M1444.779,2830.546l2.3.572.031.008a.511.511,0,0,1-.245.992l-2.369-.581a.514.514,0,1,1,.245-1h0Z",
    transform: "translate(-1415.886 -2764.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13345",
    "data-name": "Path 13345",
    d: "M1557.87,2853.891l2.364.251.028,0a.5.5,0,0,1-.1,1l-2.422-.25a.507.507,0,0,1,.1-1.009h0Z",
    transform: "translate(-1523.664 -2786.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13346",
    "data-name": "Path 13346",
    d: "M1673.234,2861.365l2.381-.039h.025a.483.483,0,0,1,.019.965l-2.431.058a.492.492,0,1,1-.023-.983h.029Z",
    transform: "translate(-1633.609 -2793.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13347",
    "data-name": "Path 13347",
    d: "M1788.862,2850.338l2.365-.306.021,0a.461.461,0,0,1,.122.914l-2.406.331a.471.471,0,0,1-.128-.933h0Z",
    transform: "translate(-1743.801 -2783.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13348",
    "data-name": "Path 13348",
    d: "M1903.356,2827.622l2.325-.542.018,0a.421.421,0,0,1,.2.818l-2.353.585a.439.439,0,0,1-.212-.852h0Z",
    transform: "translate(-1852.911 -2761.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13349",
    "data-name": "Path 13349",
    d: "M2015.579,2793.957l2.265-.763.015,0a.38.38,0,0,1,.248.719l-2.284.807a.4.4,0,0,1-.265-.751h0Z",
    transform: "translate(-1959.855 -2729.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13350",
    "data-name": "Path 13350",
    d: "M2124.5,2750.347l2.19-.965.012-.005a.34.34,0,0,1,.279.62l-2.2,1.008a.358.358,0,1,1-.3-.65h0Z",
    transform: "translate(-2063.646 -2687.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13351",
    "data-name": "Path 13351",
    d: "M2229.621,2698.137l2.108-1.139.009,0a.278.278,0,0,1,.271.486l-2.1,1.2a.307.307,0,0,1-.3-.533l.005,0Z",
    transform: "translate(-2163.809 -2637.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13352",
    "data-name": "Path 13352",
    d: "M2330.542,2637.772l2.011-1.308.006,0a.212.212,0,0,1,.236.353l-1.991,1.365a.241.241,0,1,1-.273-.4l0,0Z",
    transform: "translate(-2259.973 -2579.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13353",
    "data-name": "Path 13353",
    d: "M2426.842,2584.679l.972-.728,0,0a.145.145,0,0,1,.178.23l-.952.762a.165.165,0,0,1-.206-.257l0,0Z",
    transform: "translate(-2351.73 -2529.728)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtcAppLarge);
export default __webpack_public_path__ + "static/media/dtc_app_large.443b40c7ffac55ea9575e33f8cebf837.svg";
export { ForwardRef as ReactComponent };